const userConstants = {
  tableSize: 40,
};

export default userConstants;
